import { CartPolicy } from './types';
import { getAttr, pass } from './cartLineHelpers';

export const bundleRemovalPolicy: CartPolicy = (input, cart, meta) => {
  const clid = meta.removedLineId;
  if (!clid || !cart) return pass(input);

  const removed = cart.lines.edges.find((edge) => edge.node.id === clid);
  const bundleId = getAttr(removed?.node.attributes, '_bundle_id');
  const isParent = getAttr(removed?.node.attributes, '_is_bundle_parent') === '1';
  if (!isParent || !bundleId) return pass(input);

  const bundleLineIds = cart.lines.edges
    .filter((edge) => getAttr(edge.node.attributes, '_bundle_id') === bundleId)
    .map((edge) => edge.node.id);

  const lineItemsToRemove = Array.from(
    new Set([...(input.lineItemsToRemove ?? []), ...bundleLineIds]),
  );
  return {
    input: { ...input, lineItemsToRemove },
    reasons: ['bundle parent removal expands to children'],
  };
};
